import gsap from "gsap-trial";
import { ScrollTrigger } from "gsap-trial/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const roughEase = "steps(24)";

// Set initial state: rocket in the center, visible on top of the nut
gsap.set(".rocket", {
  xPercent: -50, // Center horizontally
  yPercent: -50, // Center vertically
  left: "50%", // Center horizontally relative to viewport
  top: "50vh", // Center vertically relative to viewport
  zIndex: 10, // Ensure it sits on top of the nut
});

// Timeline for the rocket/nut animation
const rocketNutTimeline = gsap.timeline({
  scrollTrigger: {
    trigger: ".container", // Start the animation when the user scrolls
    start: "top top", // Start immediately when the user scrolls
    end: "bottom top", // End when the rocket animation is complete
    scrub: true, // Link animation progress to scroll position
  },
});

// Rocket rocks back and forth while centered
rocketNutTimeline
  .to(".rocket", {
    rotation: -10, // Rock to the left
    yoyo: true,
    repeat: 4, // Rock back and forth a few times
    duration: 1, // Time for each rock
    ease: "power1.inOut",
  })
  .to(".rocket", {
    rotation: 0, // Return to no rotation
    duration: 1,
    ease: "power3.inOut", // Smooth easing to stop the rocking
  })
  .to(".rocket", {
    opacity: 0, // Fade out the rocket
    duration: 0.5,
    ease: "power3.inOut",
    onComplete: () => {
      document.querySelector(".rocket").style.display = "none"; // Hide the rocket after animation
    },
  })
  .from(".nut-bg", {
    opacity: 0, // Fade in the nut background
    scale: 0.8, // Scale up as it appears
    duration: 1,
    ease: "power3.inOut",
  })
  .to(
    ".nut-left",
    {
      x: "-100%",
      ease: roughEase,
      duration: 1,
    },
    "-=1"
  ) // Sync with the nut-bg appearance
  .to(
    ".nut-right",
    {
      x: "100%",
      ease: roughEase,
      duration: 1,
    },
    "-=1"
  ) // Sync with the nut-bg appearance
  .to(
    ".text",
    {
      opacity: 1,
      ease: roughEase,
      duration: 1,
    },
    "-=0.5"
  ); // Fade in the text as the nut opens

// ScrollTrigger to start the rocking animation after the main animations
ScrollTrigger.create({
  trigger: ".container",
  start: "-10%", // Adjust start point to when you want the rocking to begin
  onEnter: () => {
    console.log("Start rocking");
    createRockingAnimation(".nut-left", -1); // Start rocking for left nut
    createRockingAnimation(".nut-right", 1); // Start rocking for right nut
  },
});

// Rocking animation function for the nut halves after opening
function createRockingAnimation(target, direction) {
  gsap.to(target, {
    rotation: direction + (Math.random() * 2 - 1) * 3, // Adjust the rocking degree (positive for one direction, negative for the other)
    duration: 0.5 + Math.random() * 0.2, // Duration for one complete rocking cycle
    ease: "steps(4)",
    yoyo: true,
    repeat: -1, // Repeat indefinitely
  });
}

// Example of speech bubble animations
const speech1 = gsap.timeline({
  scrollTrigger: {
    trigger: ".heading-block-1",
    start: "top center",
    end: "center center",
    scrub: false,
  },
});

// Speech bubble animation
speech1.to(".bubble-1", {
  x: 0, // Move it to its final position
  rotation: 0, // Final rotation state
  duration: 1.5, // Adjust the duration as needed
  ease: roughEase, // Smooth ease for entry
  onEnter: () => {
    createRockingRandomAnimation(".bubble-1", 3);
  },
});

// Function for random rocking animations
function createRockingRandomAnimation(target, direction) {
  gsap
    .timeline({ repeat: -1, repeatRefresh: true }) // Timeline with repeatRefresh
    .to(target, {
      rotation: () => direction + (Math.random() * 2 - 1) * 3, // Adjust the rocking degree (positive for one direction, negative for the other)
      duration: () => 0.5 + Math.random() * 0.2, // Duration for one complete rocking cycle
      x: () => direction + (Math.random() * 2 - 1) * 6,
      y: () => direction + (Math.random() * 2 - 1) * 9,
      ease: "power1.out",
      yoyo: true,
    });
}
